import React from "react";
import { useParams } from 'react-router-dom';
import { Drawer, Group, Text, ActionIcon, Box, Divider } from '@mantine/core';
import { IconMessageChatbot, IconArrowLeft } from '@tabler/icons-react';
import { utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { sqlDateToHumanDate, safeValue, getPropInSubLevelRole, getObjectParam2 } from "../../utils/globalFunctions";

import ImageLightBox2 from "../../components/general/ImageLightBox2";
import VideoPlayerModal from "../../components/general/VideoPlayerModal";
import StepNotaDibatalkan from "../../components/utilities/StepNotaDibatalkan";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";

const ProjectDibatalkanSelected = ({
    fnRefreshNotaIndex,
    fnCloseDrawer,
    stateData
}) => {

    const { URI1 } = useParams();

    const utilsRef = React.useRef({
        projectProcess: utils.projectProcess.dibatalkan.value,
        projectIsCancel: '1',
        userAccess: [
            // role.owner.subLevel.owner.slugSubLevel,
            // role.admin.subLevel.admin_kepala.slugSubLevel,
            // role.admin.subLevel.admin_staf.slugSubLevel,
        ]
    })

    const [data, setData] = React.useState({
        imageLightboxImages: '',
        imageLightboxTitle: '',
        imageLightboxIndex: '',
        imageLightboxFieldName: '',

        imageLightboxShow: false,

        feedbackModal: false,

        mediaURL: '',
        mediaTitle: '',
        mediaShow: false
    });

    return (
        <React.Fragment>
            <Drawer
                opened={URI1}
                onClose={fnCloseDrawer}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}
                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnCloseDrawer}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Group position='apart' style={{ width: '100%' }}>
                            <Text>Dibatalkan</Text>
                            <ActionIcon
                                size='lg'
                                variant="light"
                                color="green"
                                radius='xl'
                                onClick={() => setData(d => ({ ...d, feedbackModal: true }))}
                            >
                                <IconMessageChatbot size='1.25rem' stroke={1.25} />
                            </ActionIcon>
                        </Group>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        width: '100%',
                    }
                })}
            >
                {stateData?.data &&
                    <Box
                        p='sm'
                        mb='md'
                        sx={(tema) => ({
                            backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.red[9], 0.2) : tema.fn.rgba(tema.colors.red[9], 0.2),
                            borderRadius: tema.radius.sm
                        })}
                    >
                        <Text size='sm' fw={500} tt='uppercase'>
                            Info Pembatalan
                        </Text>

                        <Divider
                            my='sm'
                            sx={(tema) => ({
                                borderColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.red[9], 0.1) : tema.fn.rgba(tema.colors.red[9], 0.1),
                            })}
                        />

                        <Text size='sm'>
                            Tanggal Dibatalkan : {sqlDateToHumanDate({
                                stateDate: stateData.data.cancel_datetime,
                                stateWithTime: true,
                                stateLang: 'id',
                                stateIsShort: false,
                                stateDay: true,
                                stateDefaultValue: ' - ',
                                stateDateType: 'day',
                                stateWithSecond: false
                            })}
                        </Text>

                        <Text size='sm'>
                            Dibatalkan Oleh : {safeValue(stateData.data.cancel_user_name, ' - ')} - {getPropInSubLevelRole(stateData.data.cancel_user_sub_level, 'caption', '-')}
                        </Text>

                        <Text size='sm'>
                            Dibatalkan Dari : {getObjectParam2(utils.projectProcess, stateData.data.cancel_from_process, 'caption', ' - ')}
                        </Text>

                        <Text size='sm'>
                            Keterangan : {safeValue(stateData.data.cancel_info, ' - ')}
                        </Text>
                    </Box>
                }

                <StepNotaDibatalkan
                    stateURI1={URI1}
                    stateUtilsRef={utilsRef.current}

                    fnRefreshNotaIndex={fnRefreshNotaIndex}

                    fnRefreshHistory={() => { }}

                    fnClickPhoto={(object) => setData(d => ({
                        ...d,
                        imageLightboxImages: object.images,
                        imageLightboxTitle: object.title,
                        imageLightboxIndex: object.index,
                        imageLightboxFieldName: object.fieldName,
                        imageLightboxShow: true,
                    }))}

                    stateShowMediaQC={true}
                    fnClickMediaImageVideo={(object) => {
                        object.type === utils.mediaQCType.image.value ?
                            setData(d => ({
                                ...d,
                                imageLightboxImages: object.images,
                                imageLightboxTitle: object.title,
                                imageLightboxIndex: object.index,
                                imageLightboxFieldName: object.fieldName,
                                imageLightboxShow: true,
                            }))
                            :
                            setData(d => ({
                                ...d,
                                mediaURL: object.name,
                                mediaTitle: object.title,
                                mediaShow: true,
                            }))
                    }}

                    fnCloseDrawer={fnCloseDrawer}
                />
            </Drawer>

            <ImageLightBox2
                stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

                stateTitle={data.imageLightboxTitle}
                stateSelectedIndex={data.imageLightboxIndex}
                stateShow={data.imageLightboxShow}
                fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
            />

            <VideoPlayerModal
                stateURL={data.mediaURL}
                stateTitle={data.mediaTitle}
                stateShow={data.mediaShow}
                fnShow={() => setData(d => ({ ...d, mediaShow: false }))}
            />

            <FeedbackDrawer
                stateShow={data.feedbackModal}
                fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
                stateData={{
                    data: stateData.data,
                }}
                fnShouldUpdateIndex={fnRefreshNotaIndex}
            />
        </React.Fragment>
    )
}

export default React.memo(ProjectDibatalkanSelected);